import styles from "../styles.module.scss";
import {AppDataType, useAppData} from "../../context/Contexts";
import {useQuery} from "@tanstack/react-query";
import {useState, useEffect} from "react";
import fetchCheck from "../../services/CheckService";
import useCustomProductQuery from "../../services/CustomProductService";
import {slugify} from "../../helpers/helpers";


function getTotalSteps(currentAppData: AppDataType | null) {
    return currentAppData?.product?.options
        && currentAppData?.product?.variants.edges.length > 1
        ? currentAppData.product.options.length  + 1 : 1;
}

export default function Step1() {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [disabledMakes, setDisabledMakes] = useState<boolean>(true);
    const [disabledModels, setDisabledModels] = useState<boolean>(true);
    const [showTrims, setShowTrims] = useState<boolean>(false);
    const [trims, setTrims] = useState<object>({});

    const {
        custom_status,
        custom_data,
        custom_error,
        custom_isFetching,
        custom_refetch
    } = useCustomProductQuery();

    let type = 'normal';
    if (window?.is_real_truck) {
        type = 'realtruck';
    } else if (window?.scs_force_custom) {
        type = 'custom';
    } else if (window?.scs_custom_endpoint) {
        type = 'custom_endpoint';
    }

    const fetchYears = async () => {
        const year = currentAppData?.year;
        const make = currentAppData?.make;
        const model = currentAppData?.model;
        const trim = currentAppData?.trim;


        let query = `?type=${type}`;
        if (make && model && year) {
            query += `&make=${make}&model=${model}&year=${year}&trim=${trim}`;
        }
        // console.log(make, model, year, query);
        const urlYears = "https://scsbiz.wearevisum.com/api/v1/years" + query;
        const response = await fetch(urlYears, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).catch(error => console.log('error', error));

        const data = await response?.json();

        return data.years;
    };
    const fetchMakes = async () => {
        const year = currentAppData?.year;
        if (!year) return [];
        let query = `?year=${year}&type=${type}`;
        const urlMakes = "https://scsbiz.wearevisum.com/api/v1/years" + query;
        const response = await fetch(urlMakes, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).catch(error => console.log('error', error));

        const data = await response?.json();
        if (data.makes.length > 0) {
            setDisabledMakes(false);
        }
        return data.makes.sort();
    }
    const fetchModels = async () => {
        const year = currentAppData?.year;
        const make = currentAppData?.make;
        if (!year) return [];
        if (!make) return [];
        let query = `?year=${year}&make=${make}&type=${type}`;
        const urlMakes = "https://scsbiz.wearevisum.com/api/v1/years" + query;
        const response = await fetch(urlMakes, {
            mode: "cors", headers: {'Access-Control-Allow-Origin': '*'}
        }).catch(error => console.log('error', error));

        const data = await response?.json();
        // console.log('models', data)
        if (Object.values(data.models).length > 0) {
            setDisabledModels(false);
        }

        if (window.scs_force_normal) {
            setTrims({});
        } else {
            setTrims(data.trims ? data.trims : {});
        }
        return Object.values(data.models).sort();
    }

    const yearsQuery = useQuery({queryKey: ['years'], queryFn: fetchYears})

    const makesQuery = useQuery({queryKey: [`makes-${currentAppData?.year}`], queryFn: fetchMakes})

    const modelsQuery = useQuery({
        queryKey: [`models-${currentAppData?.year}-${currentAppData?.make}`],
        queryFn: fetchModels
    })

    const handleYearChange = (e) => {
        setCurrentAppData(prevState => {
            return {...prevState, year: e.target.value, make: '', model: '', trim: ''}
        })
    }

    const handleMakeChange = (e) => {
        setCurrentAppData(prevState => {
            return {...prevState, make: e.target.value, model: '', trim: ''}
        })
    }

    async function runCheckNow(value: string | undefined, trim: string | undefined, has_trims: boolean) {

        return;
    }

    async function runTrims(mm) {
        // console.log('mm:', mm);
        if (trims && typeof trims[mm] !== 'undefined' && trims[mm].length === 1) {
            await runCheckNow(mm, trims[mm][0], true);
        }
    }

    const handleModelChange = async (e) => {
        await setCurrentAppData(prevState => {
            return {...prevState, model: e.target.value, trim: ''}
        })

        if (currentAppData?.year && currentAppData?.make && e.target.value) {
            //DONE: Run compat check on backend and save compatibility information
            // console.log('trims', trims, e.target.value);
            if (trims && typeof trims[e.target.value] !== 'undefined' && trims[e.target.value].length > 0) {
                await setCurrentAppData(prevState => {
                    return {...prevState, has_trims: true}
                })
                setShowTrims(true);

                setTimeout(async function () {
                    await runTrims(e.target.value);
                }, 10)


            } else {
                await runCheckNow(e.target.value, '', false);
            }
            return;
        }
        setCurrentAppData(prevState => {
            return {...prevState, check: undefined, trim: '', has_trims: false}
        });
    }

    const handleTrimChange = async (e) => {
        await runCheckNow(currentAppData?.model, e.target.value, true);
        //
        // const check = await runCheck(currentAppData?.model, e.target.value);
        // if (check.compatibility === 'N') {
        //     //alert('Need to get custom product via graphql and show the options for custom product');
        //     const product = await getCustomProduct(currentAppData?.model, e.target.value);
        //     product.images = currentAppData?.originalProduct?.images;
        //     await setCurrentAppData(prevState => {
        //         return { ...prevState, product: product }
        //     });
        //     return;
        // }
    }

    const handleClickChange = (e) => {
        setCurrentAppData(prevState => {
            return {
                ...prevState, step: 1, year: '', make: '',
                model: '', seat: '', color: 'Black', addons: '', check: undefined
            };
        })
    }


    const getCustomProduct = (value: string | undefined, trim: string) => {
        custom_refetch();
        // console.log('getCustomProduct data', custom_data);

        return custom_data;
    }

    useEffect(() => {
        if (!currentAppData?.model)
            return;
        // console.log('useEffect model');

        async function runEffect() {
        
    
            if (currentAppData?.year && currentAppData?.make && currentAppData?.model) {
                //DONE: Run compat check on backend and save compatibility information
                // console.log('runEffect trims', trims, currentAppData?.model);
                if (trims && typeof trims[currentAppData?.model] !== 'undefined' && trims[currentAppData?.model].length > 0) {
                    await setCurrentAppData(prevState => {
                        return {...prevState, has_trims: true}
                    })
                    setShowTrims(true);
    
                    setTimeout(async function () {
                        await runTrims(currentAppData?.model);
                    }, 10)
    
    
                } else {
                    await runCheckNow(currentAppData?.model, '', false);
                }
                
                return;
            }
            setCurrentAppData(prevState => {
                return {...prevState, check: undefined, trim: '', has_trims: false}
            });
        }

        runEffect();

        if (currentAppData?.has_trims) {
            // console.log('test: ', typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData?.model].length > 0);
            setShowTrims(typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData?.model].length > 0);
        } else {
            // run check
//            runCheckNow(currentAppData?.model, '', false);
        }

    }, [currentAppData?.model, trims]);

    /*useEffect(() => {
        if (!currentAppData?.trim || currentAppData?.trim === '')
            return;

        runCheckNow(currentAppData?.model, currentAppData?.trim, true);

    }, [currentAppData?.trim]);*/


    // console.log('trims', trims, currentAppData?.model, showTrims, trims && currentAppData?.model && showTrims)

    return (
        <section className={`${styles.section__step} ${window.scs_custom_style ? styles.style01 : ''} ${currentAppData?.step == 1 ? styles.section_active: ''}`} id="step_1">
            <h2>Step {currentAppData?.step}/{`${getTotalSteps(currentAppData)}`} - <strong>Vehicle Details</strong></h2>
            {currentAppData?.step === 1 ? (<>
                    <div className={`${styles.vehicle_selector} ${showTrims ? styles.has_trims : ''}`}>
                        <select id={`vehicle-year`} onChange={handleYearChange} defaultValue={currentAppData?.year}>
                            <option value="">Year</option>
                            {yearsQuery.data && yearsQuery.data.map((year, i) => {
                                return (<option key={`opt-${year}`} value={`${slugify(year)}`} selected={currentAppData?.year == year}>{year}</option>);
                            })}
                        </select>
                        <select id={`vehicle-make`} onChange={handleMakeChange} disabled={disabledMakes} defaultValue={currentAppData?.make}>
                            <option value="">Make</option>
                            {makesQuery && makesQuery.data && makesQuery.data.map((make, i) => {
                                return (<option key={`opt-${slugify(make)}`} value={`${make}`} selected={currentAppData?.make == make}>{make}</option>);
                            })}
                        </select>
                        <select id={`vehicle-model`} onChange={handleModelChange} disabled={disabledModels} defaultValue={currentAppData?.model}>
                            <option value="">Model</option>
                            {modelsQuery && modelsQuery.data && modelsQuery.data.map((model, i) => {
                                return (<option key={`opt-${slugify(model)}`} value={`${model}`} selected={currentAppData?.model == model}>{model}</option>);
                            })}
                        </select>
                        {
                            trims && currentAppData.model && showTrims ? (
                                <select id={`vehicle-trim`} onChange={handleTrimChange}>
                                    <option value="">Trim</option>
                                    {trims && typeof trims[currentAppData.model] !== 'undefined' && trims[currentAppData.model].map((trim, i) => {
                                        return (<option key={`opt-${slugify(trim)}`} value={`${trim}`}
                                                        selected={trims[currentAppData.model].length === 1 || currentAppData?.trim == trim}>{trim}</option>);
                                    })}
                                </select>) : ''
                        }

                    </div>
                    {currentAppData.check && currentAppData.check?.alert ?
                        (<div className={`${styles.vehicle_alert}`}>
                            <strong>Warning:</strong> {currentAppData.check?.alert}</div>) : ''}
                    {window.scs_step_1_bottom_text ? <div className={`${styles.bottom_text}`} dangerouslySetInnerHTML={{__html: `${window.scs_step_1_bottom_text}`}}></div> : ''}
                </>
            ) : (<div className={`${styles.summary}`}>
                <div
                    className={`${styles.selected_value}`}>{`${currentAppData?.year} ${currentAppData?.make} ${currentAppData?.model} ${currentAppData?.trim}`}</div>
                <button className={`${styles.btn_change}`} onClick={handleClickChange}>Change Vehicle</button>
            </div>)}
        </section>
    );
}


